import React, { useState } from "react";
import Logo from "../assets/img/bitcoindepot-logo.png";

import "./navigation.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";

const Navigation = () => {
  const [isOpen, SetisOpen] = useState(false);
  return (
    <>
      <Navbar light expand="md" sticky="top" style={{ background: "#fff" }}>
        <NavbarBrand href="https://bitcoindepot.com/">
          <img
            src={Logo}
            alt="logo"
            height="46px"
            width="100%"
          />
        </NavbarBrand>
        <NavbarToggler onClick={() => SetisOpen(!isOpen)} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar style={{ fontSize: "13px" }}>
            <NavItem>
              <a href="https://bitcoindepot.com/locations/" rel="noreferrer">
                LOCATIONS
              </a>
            </NavItem>
            <NavItem>
              <a href="https://bitcoindepot.com/otc/" rel="noreferrer">
                OTC
              </a>
            </NavItem>
            <NavItem>
              <a href="https://bitcoindepot.com/buy-online/" rel="noreferrer">
                BUY ONLINE
              </a>
            </NavItem>
            <NavItem>
              <a href="https://bitcoindepot.com/host/" rel="noreferrer">
                PARTNER WITH US
              </a>
            </NavItem>
            <NavItem>
              <a href="https://bitcoindepot.com/team/" rel="noreferrer">
                COMPANY
              </a>
            </NavItem>
            <NavItem>
              <a
                href="https://bitcoindepot.zendesk.com/hc/en-us"
                rel="noreferrer"
              >
                FAQ
              </a>
            </NavItem>
            <NavItem>
              <a href="https://rewards.bitcoindepot.com/" rel="noreferrer">
                REDEEM
              </a>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </>
  );
};

export default Navigation;
